import { parentApi } from "./message-proxy";

export function initPlugins() {
  parentApi.getPlugins().then(
    (plugins) => {
      for (const html of plugins) {
        const overlay = document.createElement("div");
        overlay.classList.add("websim-plugin");
        document.body.appendChild(overlay);
        setInnerHTML(overlay, html);
      }

      async function setInnerHTML(elm: Element, html: string) {
        elm.innerHTML = html;

        const oldScripts = Array.from(elm.querySelectorAll("script"));
        for (const oldScriptEl of oldScripts) {
          const newScriptEl = document.createElement("script");

          Array.from(oldScriptEl.attributes).forEach((attr) => {
            newScriptEl.setAttribute(attr.name, attr.value);
          });

          const scriptText = document.createTextNode(oldScriptEl.innerHTML);
          let promise = Promise.resolve();
          // If the script has a src attribute, wait for it to load
          if (newScriptEl.src) {
            newScriptEl.async = false;
            promise = new Promise((resolve) => {
              newScriptEl.addEventListener("load", () => {
                resolve();
              });
            });
          }
          newScriptEl.appendChild(scriptText);
          oldScriptEl.parentNode?.replaceChild(newScriptEl, oldScriptEl);
          await promise;
        }
      }
    },
    (error) => {
      console.error("error", error);
    }
  );
}
